import { useEffect } from 'react'
// Utils
import classnames from 'classnames'

import CrossIcon from './icons/Cross.inline.svg'

import Select, { SelectOptionProps } from './Select'

import styles from './allReviews.module.scss'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

export interface ReviewsFilterProps {
  sortBy: SelectOptionProps[]
  setSortBy: (val: string) => void
  onSearchReview: (val: string) => void
  setHasPhoto: (val: boolean) => void
  hasPhoto: boolean
  className?: string
  variants?: any
  productProperties?: ProductProperties
}

export const ReviewsFilter = ({ className = '', ...props }: ReviewsFilterProps) => {
  useEffect(() => {
    props.onSearchReview('')
  }, [props.onSearchReview])

  return (
    <div className={classnames(styles.filterWrap, className)}>
      <div className={styles.filterWrap__left}>
        <Select
          label="Sort By"
          options={props.sortBy}
          onChange={props.setSortBy}
          className={classnames(styles.filterOptionItem, styles.selectBoxWrap)}
          labelClassName={styles.selectBoxLabel}
          variants={props.variants}
          hasPhoto={props.hasPhoto}
          productProperties={props.productProperties}
        />
        <label className={classnames(styles.filterOptionItem, styles.photofilter)}>
          <span className={styles.photofilter__textAndInputWrapper}>HAS PHOTO </span>
          <input
            data-testid="review-section-hasphoto"
            type="checkbox"
            name="hasphoto"
            value="yes"
            onChange={e => {
              props.setHasPhoto(e.target.checked)
            }}
          />
          <div className={styles.photofilter__checkbox}>
            {props.hasPhoto && <CrossIcon className={styles.photofilter__cross} />}
          </div>
        </label>
      </div>
    </div>
  )
}

export default ReviewsFilter
